import { jsx } from "panel";
import { SegmentLegendHeaderEl } from "common/charts/misc/segment-legend-header";
import { LineChartEl } from "common/charts/visualization/line-chart";
function ChartSubtitleText({ subtitleText, isDrilledDown }) {
  return /* @__PURE__ */ jsx("div", {
    sel: ".header"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".labels"
  }, (() => {
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("span", {
      sel: ".description.mp-font-weight-medium"
    }, subtitleText.conversionText), isDrilledDown ? /* @__PURE__ */ jsx("span", {
      sel: ".conversion-percentage"
    }, subtitleText.totalConversionPercentageText) : null);
  })()));
}
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".root"
  }, this.attr(`include-header`) && this.helpers.subtitleText() ? /* @__PURE__ */ jsx(ChartSubtitleText, {
    subtitleText: this.helpers.subtitleText(),
    isDrilledDown: this.helpers.isDrilledDown()
  }) : null, /* @__PURE__ */ jsx(SegmentLegendHeaderEl, {
    sel: ".segment-header"
  }), /* @__PURE__ */ jsx(LineChartEl, {
    sel: ".line-chart",
    attrs: this.helpers.getLineChartAttrs(),
    props: this.helpers.getLineChartProps()
  }));
}
